import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-asset-compare',
  templateUrl: './asset-compare.component.html',
  styleUrls: ['./asset-compare.component.css']
})
export class AssetCompareComponent implements OnInit {

  constructor(
    private toastr: ToastrService,
    private generic_service: GenericService
  ) { }

  displayKeys: any[] = [];
  objectTemplateList: any = [];
  singleObjectTemplateData: any = [];
  objectTemplateId: any = "";


  // 🚫 system fields to exclude
  excludeKeys = [
    'id',
    'cid',
    'createdDate',
    'createdBy',
    'objectTemplateId',
    'icon',
    'iconUrl',
    'subGroups'
  ];

  ngOnInit() {
    this.getAllObjectTemplate()
    // if (this.assets.length > 0) {
    //   this.displayKeys = Object.keys(this.assets[0])
    //     .filter(key => !this.excludeKeys.includes(key));
    // }

    // if (this.singleObjectTemplateData.length > 0) {
    //   this.displayKeys = Object.keys(this.singleObjectTemplateData[0])
    // }
  }

// getObjectTemplateById(objectTemplateId: any) {
//   const id = objectTemplateId?.target?.value;
//   if (!id) return;

//   this.generic_service.getObjectTemplateById(id).subscribe(
//     (response: any) => {
//       const template = response.response;
//       this.singleObjectTemplateData = template ? [template] : [];

//       this.displayKeys = template?.nameValue?.map((item: any) => item.key) || [];
//       console.log(this.displayKeys);
//     },
//     (error: any) => {
//       console.error('Error fetching object template:', error);
//     }
//   );
// }

getObjectTemplateById(objectTemplateId: any) {
  const id = objectTemplateId?.target?.value;
  if (!id) return;

  this.generic_service.getObjectTemplateById(id).subscribe(
    (response: any) => {
      const template = response.response;
      this.singleObjectTemplateData = template ? [template] : [];

        // Flatten all keys including nested keyValue arrays with level tracking
        this.displayKeys = this.getAllKeys(template?.nameValue || []);
      console.log(this.displayKeys);
    },
    (error: any) => {
      console.error('Error fetching object template:', error);
    }
  );
}

  addKey() {
    this.displayKeys.push({
      key: '',
      value: '',
      isEdit: true
    });
  }

  removeKey(index: number) {
    this.displayKeys.splice(index, 1);
  }

  editClick(index: number) {
    const keyItem = this.displayKeys[index];
    keyItem.isEdit = true;
  }

  updateKey(index: number) {
    const keyItem = this.displayKeys[index];
    if (!keyItem.key || !keyItem.key.trim()) {
      this.removeKey(index);
      return;
    }
    keyItem.key = keyItem.key.trim();
    keyItem.isEdit = false;
  }

  getAllKeys(items: any[]): { key: string; value: string }[] {
    let keys: any = [];

    for (const item of items) {
      if (item?.key) {
        keys.push({
          key: item.key,
          value: '',
          isEdit: false
        });
      }
    }

    return keys;
  }



// getAllKeys(items: any[]): string[] {
//   let keys: any = [];

//   for (const item of items) {
//     if (item.key) {
//       keys.push({
//         key: item.key,
//         value: "",
//       });
//     }

//     // If there are nested keyValue arrays, recurse
//     if (item.keyValue && item.keyValue.length > 0) {
//       keys = keys.concat(this.getAllKeys(item.keyValue));
//     }
//   }

//   return keys;
// }


  getAllObjectTemplate(){
    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any)=>{
        this.objectTemplateList = response.response
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  // 🧠 camelCase → Human readable
  toLabel(key: string): string {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase());
  }

  isBoolean(value: any): boolean {
    return typeof value === 'boolean';
  }

  // 📊 check if values differ across objects
  isDifferent(key: string): boolean {
    const values = this.assets.map(item => item[key]);
    return new Set(values).size > 1;
  }



  object: any = {
    "createdDate": 1770290402750,
    "createdBy": 301,
    "createdByUserName": "Telecom User",
    "version": 0,
    "isActive": true,
    "description": "",
    "id": "69847ce27d7f722e68822608",
    "objectTemplateId": 252,
    "name": "Plot",
    "type": "test",
    "group": "Test Group",
    "serialNumber": false,
    "icon": null,
    "make": false,
    "model": false,
    "branch": false,
    "department": false,
    "location": false,
    "originalCost": false,
    "currentCost": false,
    "depreciationRequired": false,
    "warranty": false,
    "purchase": false,
    "quantity": false,
    "parentAssetIdFlag": false,
    "deploy": false,
    "stockPointStatus": false,

    "iconUrl": "",
    "subGroups": null,

    "cid": 97110105107,
    "uom": false
}

// component.ts
// assets: any = [
//   {
//     engine: '1197 cc, 4 Cylinders Inline, DOHC',
//     engineType: '1.2 l Kappa',
//     turbo: false,
//     fuelType: 'Petrol',
//     e20: true,
//     power: '82 bhp @ 6000 rpm',
//     torque: '114.7 Nm @ 4200 rpm',
//     emission: 'BS6 Phase 2',
//     mileage: '19 kmpl'
//   },
//   {
//     engine: '1197 cc, 4 Cylinders Inline, DOHC',
//     engineType: '1.2 l Kappa',
//     turbo: false,
//     fuelType: 'Petrol',
//     e20: true,
//     power: '82 bhp @ 6000 rpm',
//     torque: '114.7 Nm @ 4200 rpm',
//     emission: 'BS6 Phase 2',
//     mileage: '18 kmpl'
//   },
//   {
//     engine: '1197 cc, 4 Cylinders Inline, DOHC',
//     engineType: '1.2 l Kappa',
//     turbo: false,
//     fuelType: 'Petrol',
//     e20: true,
//     power: '82 bhp @ 6000 rpm',
//     torque: '114.7 Nm @ 4200 rpm',
//     emission: 'BS6 Phase 2',
//     mileage: '18 kmpl'
//   }
// ];


// comparisonFields: any = [
//   { label: 'Engine', key: 'engine' },
//   { label: 'Engine Type', key: 'engineType' },
//   { label: 'Turbocharger', key: 'turbo' },
//   { label: 'Fuel Type', key: 'fuelType' },
//   { label: 'E20 Compatibility', key: 'e20' },
//   { label: 'Max Power', key: 'power' },
//   { label: 'Max Torque', key: 'torque' },
//   { label: 'Emission Standard', key: 'emission' },
//   { label: 'Mileage', key: 'mileage' }
// ];

comparisonFields: any[] = [
  { label: 'Name', key: 'name' },
  { label: 'Type', key: 'type' },
  { label: 'Group', key: 'group' },
  { label: 'Active', key: 'isActive' },
  { label: 'Created By', key: 'createdByUserName' },
  { label: 'Version', key: 'version' },
  { label: 'Serial Number', key: 'serialNumber' },
  { label: 'Branch', key: 'branch' },
  { label: 'Department', key: 'department' },
  { label: 'Location', key: 'location' },
  { label: 'Original Cost', key: 'originalCost' },
  { label: 'Current Cost', key: 'currentCost' },
  { label: 'Depreciation Required', key: 'depreciationRequired' },
  { label: 'Warranty', key: 'warranty' },
  { label: 'Purchase', key: 'purchase' },
  { label: 'Quantity', key: 'quantity' },
  { label: 'Deploy', key: 'deploy' },
  { label: 'Stock Point Status', key: 'stockPointStatus' },
  { label: 'UOM', key: 'uom' }
];



assets: any[] = [
  // {
  //   createdDate: 1770290402750,
  //   createdBy: 301,
  //   createdByUserName: 'Telecom User',
  //   version: 0,
  //   isActive: true,
  //   description: '',
  //   id: '69847ce27d7f722e68822608',
  //   objectTemplateId: 252,
  //   name: 'Plot A',
  //   type: 'Residential',
  //   group: 'Test Group',
  //   serialNumber: false,
  //   icon: null,
  //   make: false,
  //   model: false,
  //   branch: false,
  //   department: false,
  //   location: true,
  //   originalCost: false,
  //   currentCost: false,
  //   depreciationRequired: false,
  //   warranty: false,
  //   purchase: false,
  //   quantity: false,
  //   parentAssetIdFlag: false,
  //   deploy: false,
  //   stockPointStatus: false,
  //   iconUrl: '',
  //   subGroups: null,
  //   cid: 97110105107,
  //   uom: false
  // },
    {
    createdDate: 1770290402750,
    createdBy: 301,
    createdByUserName: 'Telecom User',
    version: 0,
    isActive: true,
    description: '',
    id: '69847ce27d7f722e68822608',
    objectTemplateId: 252,
    name: 'Plot A',
    type: 'Residential',
    group: 'Test Group',
    serialNumber: false,
    icon: null,
    make: false,
    model: false,
    branch: false,
    department: false,
    location: true,
    originalCost: false,
    currentCost: false,
    depreciationRequired: false,
    warranty: false,
    purchase: false,
    quantity: false,
    parentAssetIdFlag: false,
    deploy: false,
    stockPointStatus: false,
    iconUrl: '',
    subGroups: null,
    cid: 97110105107,
    uom: false
  },
  {
    createdDate: 1770290402751,
    createdBy: 302,
    createdByUserName: 'Admin User',
    version: 1,
    isActive: true,
    description: 'Corner plot',
    id: '69847ce27d7f722e68822609',
    objectTemplateId: 252,
    name: 'Plot B',
    type: 'Commercial',
    group: 'Test Group',
    serialNumber: false,
    icon: null,
    make: false,
    model: false,
    branch: true,
    department: false,
    location: true,
    originalCost: true,
    currentCost: true,
    depreciationRequired: false,
    warranty: false,
    purchase: true,
    quantity: false,
    parentAssetIdFlag: false,
    deploy: false,
    stockPointStatus: false,
    iconUrl: '',
    subGroups: null,
    cid: 97110105108,
    uom: true
  },
  {
    createdDate: 1770290402752,
    createdBy: 303,
    createdByUserName: 'Field User',
    version: 0,
    isActive: false,
    description: 'Inactive plot',
    id: '69847ce27d7f722e68822610',
    objectTemplateId: 252,
    name: 'Plot C',
    type: 'Industrial',
    group: 'Archived Group',
    serialNumber: false,
    icon: null,
    make: false,
    model: false,
    branch: false,
    department: true,
    location: false,
    originalCost: true,
    currentCost: false,
    depreciationRequired: true,
    warranty: false,
    purchase: false,
    quantity: false,
    parentAssetIdFlag: false,
    deploy: false,
    stockPointStatus: false,
    iconUrl: '',
    subGroups: null,
    cid: 97110105109,
    uom: false
  }
];



}
